import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "w100" }
const _hoisted_2 = { id: "container" }
const _hoisted_3 = {
  key: 0,
  id: "main-content-port"
}
const _hoisted_4 = { class: "w100" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "fl w30 pad10" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "fw600" }, "フォーム作成"),
  /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"50px"} }),
  /*#__PURE__*/_createElementVNode("br")
], -1)
const _hoisted_6 = {
  class: "fl w65 pad10",
  style: {"margin-top":"30px"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = { style: {"width":"400px","margin-top":"10px"} }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_10 = { class: "w100" }
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = /*#__PURE__*/_createStaticVNode("<div class=\"w100\" style=\"margin-top:20px;\"><div class=\"fl w30 pad10\"><h5 class=\"fw600\">フォーム一覧</h5><p style=\"margin-top:50px;\"></p><br></div><div class=\"fl w60\"></div></div><div class=\"clear\"></div>", 2)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("br", null, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue3_progress_bar = _resolveComponent("vue3-progress-bar")!
  const _component_FlashNotice = _resolveComponent("FlashNotice")!
  const _component_ChukaiSidebarMenu = _resolveComponent("ChukaiSidebarMenu")!
  const _component_UserSettingsHeader = _resolveComponent("UserSettingsHeader")!
  const _component_MdTextfieldTag = _resolveComponent("MdTextfieldTag")!
  const _component_ScheduleViewLoader = _resolveComponent("ScheduleViewLoader")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_vue3_progress_bar),
    _createVNode(_component_FlashNotice),
    _createElementVNode("section", _hoisted_2, [
      _createVNode(_component_ChukaiSidebarMenu, { currentPage: `settings` }),
      (_ctx.rm.userInfo)
        ? (_openBlock(), _createElementBlock("section", _hoisted_3, [
            _createElementVNode("section", null, [
              _createVNode(_component_UserSettingsHeader, {
                selectedTab: _ctx.selectedTab,
                ref: "header"
              }, null, 8, ["selectedTab"]),
              _createElementVNode("div", _hoisted_4, [
                _hoisted_5,
                _createElementVNode("div", _hoisted_6, [
                  _createTextVNode(" 既に作成済みのフォームがあるURLを入力してください。"),
                  _hoisted_7,
                  _createTextVNode(" フォームの情報はそのままに、自動でカレンダーを設置します。 "),
                  _createElementVNode("div", _hoisted_8, [
                    _createVNode(_component_MdTextfieldTag, {
                      name: "フォームのURLを入力",
                      style: {"height":"56px","min-width":"90px","max-width":"100%"},
                      fieldStyle: `max-width: 100%;`,
                      class: "fl fs14",
                      value: _ctx.newUrl,
                      type: "url",
                      onInputValue: _ctx.inputUrl,
                      required: ""
                    }, null, 8, ["value", "onInputValue"]),
                    _createElementVNode("button", {
                      class: "pointer centered circle_button skyblueBg fs15 rad8 fl",
                      style: {},
                      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.loadForm && _ctx.loadForm(...args)))
                    }, " 読み込む "),
                    (_ctx.loading)
                      ? (_openBlock(), _createBlock(_component_ScheduleViewLoader, {
                          key: 0,
                          class: "fl"
                        }))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _hoisted_9,
              _createElementVNode("div", _hoisted_10, [
                (_ctx.form)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      innerHTML: _ctx.form.html_from
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_12
            ])
          ]))
        : _createCommentVNode("", true),
      _hoisted_14
    ])
  ]))
}